var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEventComposerGlobalContext } from '../../../composers/EventComposerGlobalContext';
import { useConfig } from '../../../context/ConfigContext';
import { useEventApi } from '../../../hooks/useEvent/useEventApi';
function spaceApiToSpace(space) {
    var _a;
    return {
        id: space.id,
        name: space.name,
        locationId: space.location_id,
        levelId: space.level_id,
        isManaged: space.is_managed,
        amenities: space.space_amenities.map(function (amenity) { return ({
            id: amenity.id,
            quantity: amenity.quantity,
            amenityId: amenity.amenity_id,
            name: amenity.amenity.name,
        }); }),
        description: space.description,
        capacity: space.capacity,
        image: space.image,
        permissions: space.permissions,
        calendar: space.calendar
            ? {
                calendarId: space.calendar.calendar_id,
                createdAt: space.calendar.created_at,
                remoteType: space.calendar.remote_type,
                spaceId: space.calendar.space_id.toString(),
                spaceResourceEmail: space.calendar.space_resource_email,
            }
            : null,
        settings: (_a = space.settings) === null || _a === void 0 ? void 0 : _a.map(function (setting) { return ({
            name: setting.name,
            slug: setting.slug,
            value: setting.value,
        }); }),
    };
}
export function useFetchInitialSpaceForComposer(_a) {
    var mainSpaceId = _a.mainSpaceId;
    var setValue = useFormContext().setValue;
    var _b = useEventComposerGlobalContext(), onError = _b.onError, levelId = _b.levelId, locationId = _b.locationId, setLevelId = _b.setLevelId, setLocationId = _b.setLocationId;
    var _c = useConfig(), tenantId = _c.tenantId, environmentUrls = _c.environmentUrls, userContext = _c.userContext, accessToken = _c.accessToken;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var fetchSpace = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).fetchSpace;
    var _d = __read(useState(false), 2), fetchingSpace = _d[0], setFetchingSpace = _d[1];
    useEffect(function () {
        if (!mainSpaceId)
            return;
        setFetchingSpace(true);
        fetchSpace({ spaceId: mainSpaceId })
            .then(function (space) {
            if (space) {
                setValue('spaces', [spaceApiToSpace(space)]);
                if (!levelId && space.level_id != null) {
                    setLevelId(String(space.level_id));
                }
                if (!locationId && space.location_id != null) {
                    setLocationId(String(space.location_id));
                }
            }
        })
            .finally(function () {
            setFetchingSpace(false);
        });
    }, [
        mainSpaceId,
        fetchSpace,
        setValue,
        levelId,
        locationId,
        setLevelId,
        setLocationId,
    ]);
    return { fetchingSpace: fetchingSpace };
}
